import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { subscriptionApi } from './apis/subscriptionApi';
import { authApi } from './apis/authApi';
import { attendanceApi } from './apis/attendanceApi';
import { requestApi } from './apis/requestApi';
import { salarySlipApi } from './apis/salarySlipApi';
import { docsApi } from './apis/companyDocApi';
import { integrationApi } from './apis/intergration';
import { aiApi } from './apis/aiApi';
import { modalReducer } from './modal';
import { notificationApi } from './apis/notificationApi';
import complianceApi from './apis/complianceApi';
import analyticsApi from './apis/analyticsApi';
import projectApi from './apis/projectApi';
export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [attendanceApi.reducerPath]: attendanceApi.reducer,
    [requestApi.reducerPath]: requestApi.reducer,
    [salarySlipApi.reducerPath]: salarySlipApi.reducer,
    [docsApi.reducerPath]: docsApi.reducer,
    [integrationApi.reducerPath]: integrationApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [aiApi.reducerPath]: aiApi.reducer,
    [complianceApi.reducerPath]: complianceApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    modal: modalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      attendanceApi.middleware,
      requestApi.middleware,
      salarySlipApi.middleware,
      docsApi.middleware,
      integrationApi.middleware,
      subscriptionApi.middleware,
      complianceApi.middleware,
      analyticsApi.middleware,
      aiApi.middleware,
      projectApi.middleware,
      notificationApi.middleware
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
